// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-top-layer-image img{height:280px;margin:1em 0}.czt-top-layer-image--aside img{max-width:350px;max-height:175px}@media(min-width: 1264px){.czt-top-layer-image--aside img{position:absolute;bottom:0;right:calc(100% / 2 - (100vw / 2 - 18px))}}", ""]);
// Exports
module.exports = exports;
